/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import Moment from 'moment';
import { ALL_ROUTES, CALENDER_SCREEN, API_CONSTANTS } from '../../global/Constants';
import { HeaderTypes } from "../../global/Enum";
import './activity-calendar.css';
import Header from '../common/Header';
import Footer from '../common/Footer';
import CustomProgress from '../common/CustomProgress';
import ActivityCount from '../common/ActivityCount';
import DesktopFooter from '../common/DesktopFooter';
import ApiServices from "../../providers/ApiServices";
import Loader from "../common/loader/Loader";
import Utilities from '../../global/Utilities';
import SyncLoader from '../common/loader/SyncLoader';

class CalendarDayPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedDate: new Date(),
      isLoading: false,
      isPlanned: false,
      activeFDO: {},
      completedActivities: {},
      reviewedActivities: {},
      completed: {},
      planned: {},
      data: null,
    }
  }

  componentDidMount() {
    if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
      let date = null;
      if (this.props.location.state !== undefined) {
        date = this.props.location.state.date;
        Utilities.LogPrint("Date", date);
        this.getActivityByDate(date);
      } else {
        this.props.history.replace(ALL_ROUTES.CALENDAR_ROUTE);
      }
    } else {
      this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
    }

  }

  getActivityByDate(date) {
    this.setState({ isLoading: true });
    var request = JSON.stringify({
      date: date
    });

    try {
      ApiServices.getActivityByDate(request)
        .then(response => {
          Utilities.LogPrint("API_DATA: ---->", response);
          this.setState({ isLoading: false });
          if (response.success) {
            const data = response.data;
            if (data != null) {
              this.setState({ data: data, selectedDate: date });
            }
          } else {
            Utilities.LogPrint("Status", response.message);
            if (response.message !== undefined && response.message) {
              this.setState({
                errorMsg: response.message
              });
            }
          }
        }).catch(error => {
          this.setState({ isLoading: false, errorMsg: error });
        });
    } catch (error) {
      this.setState({ isLoading: false, errorMsg: error });
    }
  }

  getFormattedDate() {
    let selectedDate = null;
    if (this.props.location.state !== undefined) {
      selectedDate = this.props.location.state.date;
      return Moment(selectedDate).format('dddd, DD MMM, yyyy');
    }
  }

  handleDayActivityItem(item) {
    //this.props.history.push(ALL_ROUTES.CALENDAR_DAY_FDO_SCHEDULE_ROUTE);
    this.props.history.push({
      pathname: ALL_ROUTES.CALENDAR_DAY_FDO_SCHEDULE_ROUTE,
      state: { data: item, selectedDate: this.state.selectedDate }
    });
  }


  handleToggle = () => {
    this.setState({ isPlanned: !this.state.isPlanned });
  }

  handleSyncLoading = (loading, tableName) => {
    Utilities.LogPrint("handleSyncLoading", loading + tableName);
    this.setState({ isSyncLoading: loading, tableName })
  }

  render() {
    const { data, isLoading, isPlanned, isSyncLoading, tableName } = this.state;
    if (data != null) {
      const activeFDO = data?.activeFDO;
      const completedActivities = data?.completedActivities;
      const reviewedActivities = data?.reviewedActivities;
      const completed = data?.completed;
      const planned = data?.planned;

      return (
        <div>
          <Header selectedTab={HeaderTypes.CALENDAR} handleSyncLoading={this.handleSyncLoading} />
          <Footer isActive={1} />

          <div className="container pt-35 pb-65">
            <div className="row">
              <div className="col-12">
                <h3 className="title d-flex align-items-center" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                  {/* <span>Wednesday, 9th Sept, 2020</span> */}
                  <span>{this.getFormattedDate()}</span>
                  <i className="customic ic-down-arrow ml-auto ml-md-3"></i></h3>
              </div>
            </div>

            {/* Progress Bar */}
            <div className="row progress-report">
              <div className="col-12">
                <div className="collapse show" id="collapseExample">
                  <div className="row mb-4">
                    <CustomProgress title={CALENDER_SCREEN.ACTIVE_FDO} total={activeFDO?.totalFDO} active={activeFDO?.activeFDO} />
                    <CustomProgress title={CALENDER_SCREEN.ACTIVITIES_COMPLETED} total={completedActivities.totalActivity} active={completedActivities.completedActivity} />
                    <CustomProgress title={CALENDER_SCREEN.ACTIVITIES_REVIEWED} total={reviewedActivities.totalReviewed} active={reviewedActivities.reviwedActivity} />
                  </div>
                </div>
              </div>
            </div>

            {/* Toggle Switch */}
            <div className="row">
              <div className="col-12 d-flex mt-3 align-items-center">
                <label className="ml-auto mr-2 w-25 text-right">Completed</label>
                <label className="toogle-switch">
                  <input type="checkbox" onChange={this.handleToggle} />
                  <span className="slider"></span>
                </label>
                <label className="mr-auto ml-2 w-25">Planned</label>
              </div>
            </div>

            {/* Day Activity Count */}
            {
              !isPlanned ?
                <div className="row mt-3 fod-mobile">
                  <ActivityCount styleName="count yellow" name={CALENDER_SCREEN.INDIVIDUAL_VISIT} count={completed.IV} />
                  <ActivityCount styleName="count brown" name={CALENDER_SCREEN.SAMPLE_DISTRIBUTION} count={completed.SD} />
                  <ActivityCount styleName="count blue" name={CALENDER_SCREEN.GROUP_MEET} count={completed.GM} />
                  <ActivityCount styleName="count green" name={CALENDER_SCREEN.SAMPLE_TO_SALE} count={completed.S2S} />
                </div> :
                <div className="row mt-3 fod-mobile">
                  <ActivityCount styleName="count yellow" name={CALENDER_SCREEN.INDIVIDUAL_VISIT} count={planned.IV} />
                  <ActivityCount styleName="count brown" name={CALENDER_SCREEN.SAMPLE_DISTRIBUTION} count={planned.SD} />
                  <ActivityCount styleName="count blue" name={CALENDER_SCREEN.GROUP_MEET} count={planned.GM} />
                  <ActivityCount styleName="count green" name={CALENDER_SCREEN.SAMPLE_TO_SALE} count={planned.S2S} />
                </div>
            }

            {/* <div className="row mt-3 fod-mobile">
              <ActivityCount styleName="count yellow" name={CALENDER_SCREEN.INDIVIDUAL_VISIT} count={completed.IV} />
              <ActivityCount styleName="count brown" name={CALENDER_SCREEN.SAMPLE_DISTRIBUTION} count={completed.SD} />
              <ActivityCount styleName="count blue" name={CALENDER_SCREEN.GROUP_MEET} count={completed.GM} />
              <ActivityCount styleName="count green" name={CALENDER_SCREEN.SAMPLE_TO_SALE} count={completed.S2S} />
            </div> */}

            <div className="row">
              <div className="col-12 mt-33">
                {!isPlanned ?
                  this.setCompletedActivities(completed) :
                  this.setPlannedActivities(planned)
                }
              </div>
            </div>
          </div>
          {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
          <DesktopFooter />
        </div>
      )
    } else {
      return (
        <div>
          {isLoading ? <Loader /> : null}
        </div>
      );
    }
  }


  setCompletedActivities = (data) => {
    return (
      <ul className="review-list">
        {
          data?.fdo.length ?
            data?.fdo.map((activity, i) => (
              <li key={i}>
                <a onClick={() => { this.handleDayActivityItem(activity) }}>
                  <span className="w-25 mr-auto list-title"><b>{activity.is_self === 0 ? activity.name : "Self"}</b> {(activity?.from)}</span>
                  <span className="mr-auto">{activity.completedActivity} / {activity.totalActivity} activities</span>
                  <span className={`mr-auto pending-review ${activity.pendingReviewActivity !== 0 ? "is-pending" : ""}`}>
                    <span>{activity.pendingReviewActivity} pending review</span>
                  </span>
                  {/* <span className="mr-auto pending-review">{activity.review}</span> */}
                  <i className="customic ic-go-button"></i>
                </a>
              </li>
            )) :
            null
        }

        {/* <li>
          <a onClick={this._handleActivityDetails}>
            <span className="w-25 mr-auto"><b>Jollu Naveen</b> (Village)</span>
            <span className="mr-auto">5/6 activities</span>
            <span className="mr-auto pending-review is-pending">999+ pending review</span>
            <i className="customic ic-go-button"></i>
          </a>
        </li> */}

      </ul>
    )
  }

  setPlannedActivities = (data) => {
    return (
      <ul className="review-list">
        {
          data?.fdo.length ?
            data?.fdo.map((activity, i) => (
              <li key={i}>
                <a onClick={() => { this.handleDayActivityItem(activity) }}>
                  <span className="w-25 mr-auto list-title"><b>{activity.is_self === 0 ? activity.name : "Self"}</b> {(activity?.from)}</span>
                  <span className="mr-auto mt-1">{activity.planedActivity} / {activity.totalActivity} activities</span>
                  {/* <span className={`mr-auto pending-review ${activity.pendingReviewActivity !== 0 ? "is-pending" : ""}`}>
                    <span>{activity.pendingReviewActivity} pending review</span>
                  </span> */}
                  {/* <span className="mr-auto pending-review">{activity.review}</span> */}
                  <i className="customic ic-go-button"></i>
                </a>
              </li>
            )) :
            null
        }
      </ul>
    )
  }
}

export default withRouter(CalendarDayPage)